module.exports = __webpack_public_path__ + "img/AI-manager.d894300.png";